import Fixable from "./Fixable.vue";
import HideableHeader from "./HideableHeader.vue";

export const HEADER_CELL_RENDERS = {
  fixable: Fixable,
  hideable: HideableHeader,
} as const;
